import PropTypes from 'prop-types'
import {Box, Text, Divider} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import DataTable from '~/react/components/DataTable'

import MCoinsCell from '../../../components/MCoinsCell'
import DateCell from '../../../components/DateCell'

import DescriptionCell from './DescriptionCell'

const PointsActivitiesTable = ({activities, isLoading}) => {
  const {t} = useTranslation('points')

  const columns = [
    {
      header: t('points:activitiesScreen.table.date'),
      accessorKey: 'date',
      cell: DateCell,
      maxSize: 10,
    },
    {
      header: t('points:activitiesScreen.table.description'),
      accessorKey: 'description',
      cell: DescriptionCell,
    },
    {
      header: t('points:activitiesScreen.table.mCoins'),
      accessorKey: 'mCoinsTransaction',
      cell: MCoinsCell,
      meta: {isNumeric: true},
      size: 150,
      minSize: 120,
      maxSize: 180,
    },
  ]

  return (
    <Box width="100%" overflowX={{xl: 'visible', base: 'scroll'}}>
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={4}>
        <Text fontSize="body-small" color="neutral.60">
          {t('points:activitiesScreen.showingCount', {
            count: activities.length,
          })}
        </Text>
      </Box>

      <Box width="100%" flexGrow="1" whiteSpace="nowrap">
        <Divider mt="sm" />
        <DataTable data={activities} columns={columns} isLoading={isLoading} />
      </Box>
    </Box>
  )
}

PointsActivitiesTable.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      createdAt: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      pointsAmount: PropTypes.number.isRequired,
      transactionType: PropTypes.oneOf(['credit', 'debit']).isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default PointsActivitiesTable
